import React from 'react';
import './HealthCheckLanding.css';

const HealthCheckLanding = () => {
  const features = [
    {
      icon: '📷',
      title: '결과지 스캔',
      description: '카메라로 촬영하면 OCR이 자동으로 검사 항목을 추출합니다',
      color: '#0D9488'
    },
    {
      icon: '🤖',
      title: 'AI 쉬운 해석',
      description: '어려운 의학 용어를 쉬운 한국어로 설명합니다',
      color: '#14B8A6'
    },
    {
      icon: '📊',
      title: '연도별 추이',
      description: '매년 건강 변화를 한눈에 비교합니다',
      color: '#10B981'
    },
    {
      icon: '💬',
      title: 'AI 건강 상담',
      description: '건강 관련 궁금한 점을 AI에게 질문합니다',
      color: '#059669'
    }
  ];

  const benefits = [
    { icon: '⚡', text: '3초 만에 결과 이해' },
    { icon: '🔬', text: '17개 주요 항목 분석' },
    { icon: '🔒', text: '로컬 암호화 저장' },
    { icon: '📈', text: '연도별 추이 비교' },
    { icon: '💡', text: 'AI 맞춤 건강 조언' },
    { icon: '👨‍👩‍👧‍👦', text: '가족 검진 관리' }
  ];

  return (
    <div className="hc-container">
      {/* Hero Section */}
      <section className="hc-hero">
        <div className="hc-hero-content">
          <div className="hc-hero-badge">🏥 건강검진 AI 분석</div>
          <h1 className="hc-hero-title">
            건강검진 결과,<br />
            <span className="hc-gradient-text">AI가 쉽게 알려드려요</span>
          </h1>
          <p className="hc-hero-description">
            복잡한 건강검진 결과지를 촬영하면<br />
            AI가 쉬운 말로 설명해드립니다
          </p>
          <div className="hc-hero-buttons">
            <button className="hc-btn-primary">
              무료로 시작하기
            </button>
            <button className="hc-btn-secondary">
              자세히 알아보기
            </button>
          </div>
          <div className="hc-hero-stats">
            <div className="hc-stat-item">
              <span className="hc-stat-number">17개</span>
              <span className="hc-stat-label">주요 검사 항목</span>
            </div>
            <div className="hc-stat-item">
              <span className="hc-stat-number">3초</span>
              <span className="hc-stat-label">결과 이해 시간</span>
            </div>
            <div className="hc-stat-item">
              <span className="hc-stat-number">1,750만</span>
              <span className="hc-stat-label">연간 검진 대상자</span>
            </div>
          </div>
        </div>
        <div className="hc-hero-image">
          <div className="hc-phone-mockup">
            <img src="/api/placeholder/300/600" alt="헬스체크 앱 화면" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="hc-features">
        <div className="hc-section-header">
          <h2>핵심 기능</h2>
          <p>스캔부터 분석까지, 건강검진 결과를 위한 종합 도구</p>
        </div>
        <div className="hc-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="hc-feature-card" style={{'--accent-color': feature.color}}>
              <div className="hc-feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* How It Works Section */}
      <section className="hc-how-it-works">
        <div className="hc-how-content">
          <h2>이렇게 사용해요</h2>
          <p>간편한 3단계로 건강검진 결과를 이해하세요</p>
          <div className="hc-step-cards">
            <div className="hc-step-card">
              <div className="hc-step-number">01</div>
              <h3>촬영하기</h3>
              <p>건강검진 결과지를 카메라로 촬영하면 OCR이 자동으로 인식합니다</p>
            </div>
            <div className="hc-step-card">
              <div className="hc-step-number">02</div>
              <h3>AI 해석</h3>
              <p>AI가 검사 수치를 분석하고 쉬운 말로 설명해드립니다</p>
            </div>
            <div className="hc-step-card">
              <div className="hc-step-number">03</div>
              <h3>건강 관리</h3>
              <p>생활습관 개선 팁과 연도별 추이로 건강을 관리하세요</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="hc-benefits">
        <div className="hc-benefits-content">
          <div className="hc-benefits-text">
            <h2>왜 헬스체크인가요?</h2>
            <p className="hc-benefits-description">
              어려운 의학 용어가 아닌,<br />
              쉬운 말로 알려드립니다.
            </p>
            <div className="hc-benefits-list">
              {benefits.map((benefit, index) => (
                <div key={index} className="hc-benefit-item">
                  <span className="hc-benefit-icon">{benefit.icon}</span>
                  <span>{benefit.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="hc-benefits-image">
            <img src="/api/placeholder/500/400" alt="헬스체크 분석 화면" />
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="hc-pricing">
        <div className="hc-section-header">
          <h2>요금제</h2>
          <p>나에게 맞는 플랜을 선택하세요</p>
        </div>
        <div className="hc-pricing-grid">
          <div className="hc-pricing-card">
            <h3>무료</h3>
            <div className="hc-pricing-price">0원</div>
            <p className="hc-pricing-period">연 1회 분석</p>
            <ul className="hc-pricing-features">
              <li>연 1회 검진 결과 분석</li>
              <li>기본 AI 해석</li>
              <li>참고범위 비교</li>
            </ul>
          </div>
          <div className="hc-pricing-card">
            <h3>건당 결제</h3>
            <div className="hc-pricing-price">2,900원</div>
            <p className="hc-pricing-period">1회</p>
            <ul className="hc-pricing-features">
              <li>1회 검진 결과 분석</li>
              <li>상세 AI 해석</li>
              <li>생활습관 개선 팁</li>
            </ul>
          </div>
          <div className="hc-pricing-card hc-pricing-popular">
            <div className="hc-pricing-badge">인기</div>
            <h3>월간 구독</h3>
            <div className="hc-pricing-price">4,900원</div>
            <p className="hc-pricing-period">월</p>
            <ul className="hc-pricing-features">
              <li>무제한 검진 결과 분석</li>
              <li>AI 건강 상담 챗봇</li>
              <li>연도별 추이 비교</li>
              <li>가족 검진 관리</li>
            </ul>
          </div>
          <div className="hc-pricing-card">
            <h3>연간 구독</h3>
            <div className="hc-pricing-price">29,000원</div>
            <p className="hc-pricing-period">년</p>
            <ul className="hc-pricing-features">
              <li>월간 구독 모든 기능</li>
              <li>50% 할인</li>
              <li>우선 고객 지원</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="hc-testimonials">
        <h2>사용자 후기</h2>
        <div className="hc-testimonials-grid">
          <div className="hc-testimonial-card">
            <div className="hc-stars">⭐⭐⭐⭐⭐</div>
            <p>"건강검진 결과를 받을 때마다 뭐가 뭔지 몰랐는데, 헬스체크로 촬영하니까 3초 만에 이해됐어요."</p>
            <div className="hc-testimonial-author">
              <strong>김민수</strong>
              <span>40대 직장인</span>
            </div>
          </div>
          <div className="hc-testimonial-card">
            <div className="hc-stars">⭐⭐⭐⭐⭐</div>
            <p>"매년 검진 결과를 비교해볼 수 있어서 건강 관리에 큰 도움이 됩니다. AI 상담도 친절하고 정확해요."</p>
            <div className="hc-testimonial-author">
              <strong>박지영</strong>
              <span>30대 워킹맘</span>
            </div>
          </div>
          <div className="hc-testimonial-card">
            <div className="hc-stars">⭐⭐⭐⭐⭐</div>
            <p>"부모님 검진 결과도 함께 관리할 수 있어서 좋아요. 어려운 의학 용어를 쉽게 설명해줘서 부모님도 이해하세요."</p>
            <div className="hc-testimonial-author">
              <strong>이준호</strong>
              <span>50대 자영업자</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="hc-cta">
        <div className="hc-cta-content">
          <h2>지금 바로 시작하세요</h2>
          <p>건강검진 결과, 3초면 이해할 수 있습니다</p>
          <div className="hc-cta-buttons">
            <button className="hc-btn-download">
              <span>🤖</span> Google Play
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="hc-footer">
        <div className="hc-footer-content">
          <div className="hc-footer-section">
            <h3>헬스체크</h3>
            <p>건강검진 AI 분석 앱</p>
          </div>
          <div className="hc-footer-section">
            <h4>제품</h4>
            <ul>
              <li><a href="#features">기능</a></li>
              <li><a href="#how-it-works">사용법</a></li>
              <li><a href="#faq">FAQ</a></li>
            </ul>
          </div>
          <div className="hc-footer-section">
            <h4>회사</h4>
            <ul>
              <li><a href="#about">소개</a></li>
              <li><a href="#contact">문의</a></li>
            </ul>
          </div>
          <div className="hc-footer-section">
            <h4>법적 고지</h4>
            <ul>
              <li><a href="/healthcheck/terms">이용약관</a></li>
              <li><a href="/healthcheck/privacy">개인정보처리방침</a></li>
              <li><a href="/healthcheck/account-deletion">계정 삭제</a></li>
            </ul>
          </div>
        </div>
        <div className="hc-footer-bottom">
          <p>&copy; 2026 헬스체크(Health Check). All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default HealthCheckLanding;
